import * as yup from "yup";
import { PASSWORD_UPPERCASE_REGEX, PASSWORD_DIGIT_REGEX, PASSWORD_SPECIAL_CHAR_REGEX } from "../regex";
import { EMAIL_REGEX } from "../../constants/authConstants";

export const RESET_PASSWORD_SCHEMA = yup.object({
	password: yup
		.string()
		.required("Password is required")
		.min(8, "Minimum 8 characters")
		.matches(PASSWORD_UPPERCASE_REGEX, "One uppercase letter required")
		.matches(PASSWORD_DIGIT_REGEX, "One number required")
		.matches(PASSWORD_SPECIAL_CHAR_REGEX, "One special character required"),
	confirmPassword: yup
		.string()
		.required("Confirm password is required")
		.oneOf([yup.ref("password")], "Confirm Password should match with the New Password"),
});

export const FORGOT_EMAIL_SCHEMA = yup
	.string()
	.required("Email is required.")
	.matches(EMAIL_REGEX, "Please enter a valid email.");